import React, { useCallback } from 'react';
import {
  ListBase,
  ListToolbar,
  Pagination,
  Title,
  useListContext,
} from 'react-admin';

import { Card, Divider, Tabs, Tab } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  rootCard: { borderRadius: 12 },
}));

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

/**
 * tabs: [{ id, name, filter }]
 * - filter: objeto que será mesclado em setFilters quando a tab for selecionada
 *
 * renderGrid: função ({ listProps, classes, listContext }) => JSX (Datagrid)
 */
const ListPageTabbed = ({
  title,
  filters,
  perPage = 50,
  toolbarActions = null,
  tabs = [],
  renderGrid,
  listProps = {},
  filterDefaultValues,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <ListBase
      perPage={perPage}
      filterDefaultValues={filterDefaultValues}
      {...listProps}
    >
      <InnerTabList
        title={title}
        filters={filters}
        toolbarActions={toolbarActions}
        tabs={tabs}
        renderGrid={renderGrid}
        classes={classes}
        {...rest}
      />
    </ListBase>
  );
};

// Valor de filtro em array (ex.: status: ['a', 'b']) é comparado pelo conteúdo,
// ignorando a ordem; os demais valores continuam comparados com ===.
const isValueMatch = (tabValue, filterValue) => {
  if (Array.isArray(tabValue)) {
    return (
      Array.isArray(filterValue) &&
      filterValue.length === tabValue.length &&
      tabValue.every((v) => filterValue.includes(v))
    );
  }
  return filterValue === tabValue;
};

const isFilterMatch = (tabFilter = {}, filterValues = {}) => {
  if (!tabFilter || Object.keys(tabFilter).length === 0)
    return Object.keys(filterValues || {}).length === 0;
  return Object.keys(tabFilter).every((k) =>
    isValueMatch(tabFilter[k], (filterValues || {})[k]),
  );
};

const InnerTabList = ({
  title,
  filters,
  toolbarActions,
  tabs,
  renderGrid,
  classes,
  ...props
}) => {
  const listContext = useListContext();
  const { filterValues = {}, setFilters, displayedFilters } = listContext || {};

  // encontra tab ativa pela comparação dos filtros
  const activeTab = tabs.find((t) => isFilterMatch(t.filter, filterValues)) ||
    tabs[0] || { id: 'all', name: 'All', filter: {} };
  const activeId = activeTab.id;

  const handleChange = useCallback(
    (event, tabId) => {
      const tab = tabs.find((t) => t.id === tabId);
      if (!tab) return;
      const newFilters = { ...(filterValues || {}), ...(tab.filter || {}) };
      if (setFilters) setFilters(newFilters, displayedFilters);
    },
    [tabs, filterValues, setFilters, displayedFilters],
  );

  return (
    <>
      <Title title={title} />
      <ListToolbar
        filters={props.filters || filters}
        actions={toolbarActions}
        {...props}
      />
      <Card className={classes.rootCard}>
        <Divider />
        {Array.isArray(tabs) && tabs.length > 0 && (
          <>
            <Tabs
              variant="fullWidth"
              centered
              value={activeId}
              onChange={handleChange}
              //indicatorColor="primary"
              TabIndicatorProps={{
                style: {
                  backgroundColor: '#09f056',
                  height: 4,
                },
              }}
            >
              {tabs.map((choice) => (
                <Tab key={choice.id} label={choice.name} value={choice.id} />
              ))}
            </Tabs>
            <Divider />
          </>
        )}
        <div>{renderGrid({ listProps: props, classes, listContext })}</div>
        <TransacoesPagination />
      </Card>
    </>
  );
};

export default ListPageTabbed;
